import * as R from 'ramda'
import createReducer from 'utils/redux/createReducer'

const initialState = {
	username: ''
  , userID: ''
  , password: undefined
  , authenticated: undefined
}

let userByName = name => x => (
	(x.type == 'manager' && x.name.toLowerCase() == name)
 || (x.type == 'owner'   && x.firstName.toLowerCase().replace(/LLC/gi,"").replace(/\ |&/gi,"_").replace(/^_+|_+$|__/gi, "") == name)
)

export default createReducer(initialState, {
	LOGIN: (state, action) => ({
		...state
	  , username: action.data.username
	  , password: action.data.password
	  , authenticated: false
	})
  , LOGIN_OK: (state, action, megaState) => ({
		...state
	  , authenticated: true
	  , password: ''
	  , userID: megaState.data.replicated == state.username ? state.userID : ''
	})
  , LOGIN_FAIL: (state, action) => ({
  		...state
	  , authenticated: false
  	})
  , DATA_DOWNLOAD_OK: (state, action) => ({
  		...state
  	  , userID: R.find(userByName(state.username), R.values(action.data))._id
  	})
  , LOGOUT: (state, action) => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/session.js